function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';
import SelectInput from '../select-input';
import { useFormattedWorkTypes } from './use-formatted-work-types';
const SelectInputProjectTypes = props => {
  const formattedWorkTypes = useFormattedWorkTypes(props);
  return /*#__PURE__*/React.createElement(SelectInput, _extends({}, props, {
    options: formattedWorkTypes,
    isMulti: true,
    placeholder: props.placeholder || 'Choisir un type de projet'
  }));
};
SelectInputProjectTypes.defaultProps = {
  isBtoB: false,
  isGetir: false
};
SelectInputProjectTypes.propTypes = {
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  isBtoB: PropTypes.bool,
  isGetir: PropTypes.bool
};
export default withTheme(SelectInputProjectTypes);